// extracted by mini-css-extract-plugin
export default {"selectItem":"FabricUIControls_selectItem__3v7nR"};